import classes from "../homePageNew.module.css";
import { DownloadIcon, EyeIcon, OpenIcon } from "./icons";
import { reportDownloadUrl, openReportInNewTab, mapLlmLabels } from "../api/homePageApi";
import { downloadFile } from "../../../BrandOnBoarding/api";
import ReportStatusChip from "./ReportStatusChip";
import OverflowPill from "./OverflowPill";

function formatDateTime(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

/**
 * One report row — everything on a single line (status, type, category,
 * market, persona, models, date, actions), each field truncating with a
 * hover tooltip for its full value rather than wrapping onto a second line.
 * `showType` defaults true; Discovery passes false — its reports don't
 * carry the Brand/Product-style `type` distinction Brand Audit/Category
 * Analysis do. Shared by ReportStrip.js's single "latest report" row.
 */
export default function ReportRow({ jobId, status, type, showType = true, category, market, persona, llms, date, onView, brand }) {
  return (
    <div className={classes.reportRow}>
      <ReportStatusChip status={status} />
      {showType && <span className={classes.rtype}>{type || "Report"}</span>}
      {brand && (
        <span className={`${classes.reportBadge} ${classes.reportBadgeTight}`} title={brand}>
          {brand}
        </span>
      )}
      {category && (
        <span className={`${classes.reportBadge} ${classes.reportBadgeTight}`} title={category}>
          {category}
        </span>
      )}
      <OverflowPill values={market} label="Markets" />
      <OverflowPill values={persona} label="Personas" />
      <OverflowPill values={mapLlmLabels(llms)} label="Models" mono />
      <span className={classes.reportRowDate} title={formatDateTime(date)}>
        {date ? new Date(date).toLocaleDateString() : ""}
      </span>
      <span className={classes.reportActions}>
        <span onClick={() => onView(jobId)} title="View report">
          <EyeIcon size={15} />
        </span>
        <span onClick={() => openReportInNewTab(jobId)} title="Open in new tab">
          <OpenIcon size={15} />
        </span>
        <span onClick={() => downloadFile(reportDownloadUrl(jobId), `Report ${jobId}.html`)} title="Download">
          <DownloadIcon size={15} />
        </span>
      </span>
    </div>
  );
}
